<template>
  <v-sheet class="bg-background flex-1-1 px-4" max-width="600">
    <div class="text-h5 text-center mb-8 font-weight-medium">
      Order Information: {{ order.orderId }}
    </div>
    <v-row>
      <v-col cols="6">
        <div>Registration Level:</div>
      </v-col>
      <v-col cols="6" class="text-right">
        {{ order.productVariant?.product.teamLevel?.team_level }}
      </v-col>
    </v-row>
    <v-row class="justify-space-between">
      <v-col cols="6">
        <div>Order total:</div>
      </v-col>
      <v-col cols="6" class="text-right">
        <div>${{ amount.toFixed(2) }}</div>
      </v-col>
    </v-row>
    <v-row class="justify-space-between">
      <v-col cols="6">
        <div>Date:</div>
      </v-col>
      <v-col cols="6" class="text-right">
        <div>{{ formatDateFieldInput(order.modified_on) }}</div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" md="6">
        <v-row>
          <div>Billing</div>
        </v-row>
        <v-row> Name: {{ order.billing_name }} </v-row
        ><v-row> Address: {{ order.billing_street_address }} </v-row
        ><v-row> City: {{ order.billing_city }} </v-row
        ><v-row> State: {{ order.billing_state }} </v-row
        ><v-row> Country: {{ order.billing_country }} </v-row
        ><v-row> Postal Code: {{ order.billing_postal_code }} </v-row><v-row> </v-row>
      </v-col>

      <v-col cols="12" md="6">
        <v-row> <div>Card</div> </v-row><v-row> Ending With {{ order.card?.last4 }} </v-row
        ><v-row> Expires: {{ order.card?.exp_month }}/{{ order.card?.exp_year }} </v-row>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script setup lang="ts">
import { IOrderDTO, OrderDTO } from '@/dtos';
import { computed } from 'vue';
import { formatDateFieldInput } from '@/helpers';

interface Props {
  order: IOrderDTO;
}
const props = defineProps<Props>();
const order = computed(() => new OrderDTO(props.order));
const amount = computed(() => order.value.amount);
</script>
